import React from 'react'
import { Stack } from '@mui/material'
import LimiteLCTCUnidadNegocio from './LimiteLCTCUnidadNegocio'
import CardLimite from 'src/pages/limites/CardLimite'
import { SistemaTipo } from 'src/types/enum/enum'
import { OperacionLCTCLimitesAprobadosPais } from '../../sistema/sistemas/lctc/types/dto'
import { OperacionLCTCLimitesAprobadosPaisFields, OperacionLCTCLimitesAprobadosUnidadNegocioFields } from '../../sistema/sistemas/lctc/types/fields'

interface LimiteLCTCProps {
    data: OperacionLCTCLimitesAprobadosPais
}

function LimiteLCTC({ data }: LimiteLCTCProps) {
    return (
        <Stack gap={1}>
            <CardLimite
                codSistema={SistemaTipo.LCTC}
                codPais={data[OperacionLCTCLimitesAprobadosPaisFields.CodPais]}
                pais={data[OperacionLCTCLimitesAprobadosPaisFields.NombrePais]}
            />

            {data[OperacionLCTCLimitesAprobadosPaisFields.ListaUnidadesNegocio].map((unidad, index) => (
                <LimiteLCTCUnidadNegocio key={`unidad-negocio-${unidad[OperacionLCTCLimitesAprobadosUnidadNegocioFields.CodUnidadNegocio]}-${index}`} data={unidad} />
            ))}
        </Stack>
    )
}

export default LimiteLCTC
